<ng-template [tshAttachTo]="target">
  <ts-button actionName="Button"
             data-cy="add-to-dashboard-button"
             buttonType="button"
             (clicked)="emitAdd()">
    {{ 'shared.ui.addToDashboardButton.buttonText' | translate }}
  </ts-button>
</ng-template>
